<template lang='pug' src='./custom-meet-team.pug'></template>

<script>
import { showModal } from 'components/mixins'

export default {
  props: ['props'],
  mixins: [showModal]
}
</script>



// WEBPACK FOOTER //
// custom-meet-team.vue?0d6336e8